import { MdClose } from "react-icons/md";
import Button from "screens/Private/Broker/Projects/Detail/Templates/Comparison/MutualMobility/Components/Button";
import Header from "../../../../Header";
import ContactUs from "../../../../SVG/ContactUs";

function EmailSent({ onClose }) {
  return (
    <div className="mutualMobility-help__modal">
      <Header
        small
        subtitle={<ContactUs size={46} color="#FBBE06" />}
        title="Nous allons vous recontacter dans <b>les plus brefs délais</b>"
        highlight="vous recontacter"
      />
      <Button
        width={"auto"}
        type={"primary-outlined"}
        onClick={onClose}
        className="mt-24"
      >
        <MdClose /> Fermer
      </Button>
    </div>
  );
}

export default EmailSent;
